import {
  getSKUparts,
  getProductCategory,
  ProductCategory
} from '@spokeldn/common-sku-functions'
import { CreateReturnProduct, ReturnsProduct } from '../types'
import { RETURN_REASON_CODES } from '@components/returns/consts'

const TOP_CUT: Record<string, string> = {
  Slim: 'SL',
  Straight: 'RG',
  Dadletic: 'DD'
}
const TOP_LENGTH: Record<string, string> = {
  Short: 'SH',
  Regular: 'RG',
  Long: 'LG'
}
const TOP_SIZE: Record<string, string> = {
  XS: 'XS',
  S: 'SS',
  M: 'MM',
  'M+': 'MP',
  L: 'LL',
  'L+': 'LP',
  XL: 'XL',
  XXL: '2X',
  XXXL: '3X'
}

export const mapProductsToReturnedProducts = (
  products: ReturnsProduct[]
): CreateReturnProduct[] => {
  return products.map(product => {
    const exchangeItem: Record<string, unknown> = {}
    let returnReason = 'OTHER'

    if (product.return?.reason && [60, 61].includes(product.return?.reason)) {
      returnReason = 'ITEM_DOES_NOT_FIT'
    }

    if (product.return?.sizes) {
      exchangeItem['sizes'] = product.return.sizes
      exchangeItem['sku'] = getUpdatedSKUWithNewSize(
        product.sku,
        product.return.sizes
      )
    }

    if (product.return?.color) {
      exchangeItem['color'] = {
        title: product.return.color.title,
        image: product.return.color.image,
        productId: product.return.color.product_id.toString()
      }

      if (product.return.color.sku_16) {
        exchangeItem['sku'] = getUpdatedSKUWithNewSize(
          product.sku,
          product.return.sizes,
          true,
          product.return.color.sku_16
        )
      }
    }

    return {
      salesItemId: product.sale_item_id,
      reason: returnReason,
      returnReasonId: product.return?.reason || RETURN_REASON_CODES.OTHER,
      returnItemType: product.return?.method.toUpperCase(),
      returnReasonDetail: product.return?.reason_detail || [],
      ...(product.return?.method === 'exchange' && { exchangeItem })
    }
  }) as unknown as CreateReturnProduct[]
}

const getUpdatedSKUWithNewSize = (
  existingSKU: string,
  newSize: Record<string, string>,
  isColourExchange = false,
  partialSKU = ''
) => {
  const {
    partialSKU: { type, style, color },
    season
  } = getSKUparts(existingSKU)

  const newSKU = isColourExchange
    ? partialSKU
    : `${type}-${style}-${color}-${season}`

  const category = getProductCategory(existingSKU)
  if (ProductCategory.TROUSERS === category) {
    return `${newSKU}-${newSize.waist}${newSize.build}${newSize.leg}${
      newSize.lowerLeg || '00'
    }`
  }

  if (ProductCategory.SHORTS === category) {
    return `${newSKU}-${newSize.waist}${newSize.build}${
      newSize.leg || newSize.shortsleg || '00'
    }00`
  }

  if (ProductCategory.TOPS === category) {
    const size = newSize.chest_size || newSize.size
    return `${newSKU}-${TOP_SIZE[size] || size || ''}-${
      TOP_LENGTH[newSize.length] || ''
    }${TOP_CUT[newSize.cut] || ''}`
  }

  if (ProductCategory.ACCESSORIES === category) {
    return `${newSKU}-${newSize.waist || newSize.size}`
  }
}
